/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.09.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import DocumentTitle from 'react-document-title';
import Translate from '../components/Translate';

import ShowcaseFavorites from '../containers/ShowcaseFavorites';

import {GetPackages} from '../actions/collection/actions-collection';

class ShowcaseFavoritesRoute extends Component {

  componentWillMount() {
    this.props.GetPackages();
  }

  render() {

    return (<DocumentTitle title={Translate.translator('page.favorites')}>
      <ShowcaseFavorites />
    </DocumentTitle>);
  }
}

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({GetPackages}, dispatch);
};

export default connect(() => ({}), mapDispatchToProps)(ShowcaseFavoritesRoute);



// WEBPACK FOOTER //
// ./src/routes/favorites-route.js